<template>
  <div class="wrap">
    <div class="bannerimg relative">
      <img style="height: 480px" src="@/assets/image/lunbo/lunbo2.png" alt="" class="w-full" />
      <div class="biaotowenzi absolute top-1/2 left-1/4 -translate-y-1/2 text-white text-left p-5 z-2">
        <h2 class="text-6xl font-bold leading-[101.36px]">
          信息与通信方案服务提供商
        </h2>
        <br />
        <p class="text-lg font-bold leading-10">诚信、务实、创新、进取</p>
      </div>
    </div>
    <div class="nav-placeholder"></div>
    <Nav class="fixed-nav" :nav-items="[
      { id: 1, title: '公司介绍', path: '/workspace#intro', anchor: '#intro' },
      { id: 2, title: '发展历程', path: '/workspace#history', anchor: '#history' },
      { id: 3, title: '合作伙伴', path: '/workspace#partners', anchor: '#partners' },
      { id: 4, title: '公司资质', path: '/workspace#certificates', anchor: '#certificates' },
      { id: 5, title: '公司动态', path: '/workspace#news', anchor: '#news' },
      { id: 6, title: '联系我们', path: '/workspace#contact', anchor: '#contact' },
    ]" :active-anchor="activeAnchor" @nav-change="handleNavChange" />
    <div class="pagew content mt-3">
      <div class="logo">
        <div class="top-txt text-4xl font-bold text-center" id="intro">
          公司介绍
        </div>
        <div class="leasing-container max-w-7xl mx-auto px-5 py-10">
          <div class="content-row flex items-center mb-16 flex-row-reverse">
            <div class="text-content">
              <ul class="list-none p-0">
                <li class="flex items-start text-xl leading-10 text-gray-600 mb-4">
                  <img src="@/assets/other/element/dian.png" class="w-2.5 h-2.5 object-contain mt-5 mr-4" />
                  广州鹏海信息科技成立于大数据、云计算风靡的2016年，
                  创业团队来自一线高科技企业。是一家以通信网络系统集成、应用、销售、服务为一体的高科技企业。
                </li>
                <li class="f2">
                  <img src="@/assets/other/element/dian.png" class="w-2.5 h-2.5 object-contain mt-5 mr-4" />
                  公司主要业务是提供网络及网络安全基础构咨询、
                  设计及运维一体化技术支持服务，融合具备运营商及银行骨
                  干网络规划设计的专家团队，提供基础网络运维支撑服务
                  ，基于ITIL标准搭建7*24的运维服务团队及标准服务，提供双语支持服务。
                </li>
                <br /><br /><br /><br />
                <li class="flex items-start text-xl leading-10 text-gray-600 mb-4">
                  <img src="@/assets/other/element/dian.png" class="w-2.5 h-2.5 object-contain mt-5 mr-4" />
                  研发团队自主创新开发IT运维服务标准流程软件及运维监控管理平台，
                  与主流的网络及网络安全厂商建立合作伙伴关系，为相关合作伙伴及
                  最终用户降本增效，提升IT服务质量，公司同时提供第三方
                  网络备件支持服务。
                </li>
              </ul>
            </div>
            <div class="image-content tu2">
              <img src="@/assets/image/gongsidizhi.png" alt="服务优势示意图" class="w-[451.27px]" style="height: 420px" />
            </div>
          </div>
        </div>
        <div class="fazhan-container mt-12 h-128 relative flex justify-center items-center">
          <div class="fazhan-overlay absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-4/5 z-2">
            <div class="fanzhanlicheng text-4xl font-bold text-center mb-3" id="history">
              发展历程
            </div>
            <img src="@/assets/image/发展历程.png" alt="流程图" class="w-full h-auto object-contain block" />
          </div>
        </div>
        <!-- <br /><br /><br /><br /><br /><br /><br /> -->
        <div class="service mt-8 h-144 relative flex justify-center items-center">
          <div class="partners-content absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full z-2">
            <h2 class="partners-title text-4xl font-bold text-center mb-24" id="partners">
              合作伙伴
            </h2>
            <br /><br />
            <div class="hezuohuoban">
              <img src="@/assets/other/icons/hzhblogo.png" alt=""
                class="w-9/10 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-2" />
            </div>
          </div>
        </div>
        <div class="kuangdu mt-2">
          <div class="top-title text-4xl font-bold text-center" id="certificates">
            公司资质
          </div>
          <div class="company-certificates relative w-full h-128 mx-auto text-center">
            <div class="certificate-group outer-layer absolute left-1/2 -translate-x-1/2 whitespace-nowrap">
              <div class="certificate-card small left-outer cursor-pointer" data-id="2"
                @click="showFullImage(require('@/assets/zhengjian/2.jpg'))" @mouseenter="moveToFront(2)">
                <div class="certificate-img-container">
                  <img src="@/assets/zhengjian/paixu/2-1.png" alt="环境管理体系认证证书" />
                </div>
              </div>
              <div class="certificate-card small right-outer cursor-pointer" data-id="3"
                @click="showFullImage(require('@/assets/zhengjian/3.jpg'))" @mouseenter="moveToFront(3)">
                <div class="certificate-img-container">
                  <img src="@/assets/zhengjian/paixu/3-1.png" alt="职业健康安全管理体系认证证书" />
                </div>
              </div>
            </div>
            <div class="certificate-group middle-layer absolute left-1/2 -translate-x-1/2 whitespace-nowrap">
              <div class="certificate-card medium left-middle cursor-pointer" data-id="4"
                @click="showFullImage(require('@/assets/zhengjian/4.jpg'))" @mouseenter="moveToFront(4)">
                <div class="certificate-img-container">
                  <img src="@/assets/zhengjian/paixu/4-1.png" alt="信息技术服务管理体系认证证书" />
                </div>
              </div>
              <div class="certificate-card medium right-middle cursor-pointer" data-id="5"
                @click="showFullImage(require('@/assets/zhengjian/5.jpg'))" @mouseenter="moveToFront(5)">
                <div class="certificate-img-container">
                  <img src="@/assets/zhengjian/paixu/5-1.png" alt="信息安全管理体系认证证书" />
                </div>
              </div>
            </div>
            <div class="certificate-group center-layer absolute left-1/2 -translate-x-1/2 whitespace-nowrap">
              <div class="certificate-card large cursor-pointer" data-id="1"
                @click="showFullImage(require('@/assets/zhengjian/1.jpg'))" @mouseenter="moveToFront(1)">
                <div class="certificate-img-container">
                  <img src="@/assets/zhengjian/paixu/质量证书.jpg" alt="质量管理体系认证证书" />
                </div>
              </div>
            </div>
            <div
              class="image-modal fixed top-0 left-0 w-full h-full bg-black/80 z-1000 flex justify-center items-center"
              v-if="showModal" @click.self="closeModal">
              <div class="modal-content relative max-w-9/10 max-h-9/10">
                <img :src="currentImage" alt="放大图片" class="max-h-70vh max-w-90vw mx-auto shadow-lg" />
                <div class="image-nav flex justify-center mt-5 gap-2">
                  <div class="nav-item w-15 h-10 cursor-pointer opacity-70 transition-all border-2 border-transparent"
                    v-for="(img, index) in allImages" :key="index" @click="switchImage(img)" :class="{
                      'opacity-100 border-white': currentImage === img,
                    }">
                    <img :src="img" :alt="'缩略图' + index" class="w-full h-full object-cover" />
                  </div>
                </div>
                <button
                  class="close-btn absolute top-[-40px] right-0 bg-transparent border-none text-white text-3xl cursor-pointer"
                  @click="closeModal">
                  ×
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="dontai mt-20 w-auto h-auto">
          <div class="top-title text-4xl font-bold text-center" id="news">
            公司动态
          </div>
          <div class="gsdt">
            <div class="news-list">
              <div class="news-item" v-for="(news, idx) in dynamicList" :key="idx">
                <div class="news-date">
                  <div class="news-day">{{ news.eventDate.split("-")[2] }}</div>
                  <div class="news-month-year">
                    {{ news.eventDate.split("-")[1] }} /
                    {{ news.eventDate.split("-")[0] }}
                  </div>
                </div>
                <div class="news-content">
                  <div class="news-title">{{ news.title }}</div>
                  <div class="news-summary">{{ news.contentSummary }}</div>
                  <!-- <router-link class="read-more-btn" :to="'/news/'+news.id">阅读详情</router-link> -->
                  <router-link class="read-more-btn"
                    :to="{ name: 'NewsDetail', params: { id: news.id } }">阅读详情</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="lianxi">
          <div id="contact" class="top-title text-4xl font-bold text-center mb-8 mt-20">
            联系我们
          </div>
          <img style="width: 970px; height: auto" src="@/assets/联系方式.png" alt="" class="object-contain w-4/5" />
        </div>
      </div>
    </div>
    <Footer class="workspace-footer" :show="true" />
  </div>
</template>

<script>
import newsApi from "@/api/news";
import Nav from "../../components/Nav/Nav.vue";
import Footer from "../../components/Footer/index.vue";
import { debounce } from "lodash";
import { getDynamicList } from "@/api/api.js";

export default {
  name: "workspace",
  components: {
    Nav,
    Footer,
  },
  data() {
    return {
      dynamicList: [],
      dynamicTotal: 0,
      newsItems: [
        {
          id: 1,
          date: "2024-03-15",
          title: "澎海科技成功举办HCIE认证培训",
          summary:
            "澎海科技近日成功举办了华为HCIE认证培训课程，吸引了众多IT专业人士参与。此次培训旨在提升学员的网络技术能力，助力职业发展。",
          link: "/news/1",
        },
        {
          id: 2,
          date: "2024-03-10",
          title: "澎海科技推出新一代DDI解决方案",
          summary:
            "澎海科技发布了新一代DDI（DNS、DHCP、IPAM）解决方案，为企业网络管理提供更高效、更安全的服务。",
          link: "/news/2",
        },
        {
          id: 3,
          date: "2024-03-05",
          title: "澎海科技与金融机构达成战略合作",
          summary:
            "澎海科技与多家金融机构达成战略合作，共同推进金融科技领域的创新与发展。",
          link: "/news/3",
        },
        {
          id: 4,
          date: "2024-02-28",
          title: "澎海科技云服务升级完成",
          summary:
            "澎海科技宣布完成云服务平台的全面升级，为用户提供更稳定、更高效的云服务体验。",
          link: "/news/4",
        },
        {
          id: 5,
          date: "2024-02-20",
          title: "澎海科技江西市场取得重大突破",
          summary:
            "澎海科技在江西市场取得重大突破，成功签约多个重要项目，进一步扩大市场份额。",
          link: "/news/5",
        },
      ],
      list: ["公司简介", "招贤纳士"],
      currentIndex: 0,
      showModal: false,
      currentImage: "",
      activeAnchor: "#intro",
      scrollTimeout: null,
      allImages: [
        require("@/assets/zhengjian/1.jpg"),
        require("@/assets/zhengjian/2.jpg"),
        require("@/assets/zhengjian/3.jpg"),
        require("@/assets/zhengjian/4.jpg"),
        require("@/assets/zhengjian/5.jpg"),
      ],
    };
  },
  created() {
    this.fetchTop5News();
  },
  methods: {
    async getDynamicList() {
      const response = await getDynamicList();
      this.dynamicList = response.rows;
      this.dynamicTotal = response.total;
      console.log(response.data);
    },
    fetchTop5News() {
      this.loading = true;
      try {
        // 这里可以添加获取新闻的逻辑
        this.loading = false;
      } catch (err) {
        console.error("获取最新新闻失败:", err);
        this.loading = false;
      }
    },
    scrollToAnchor(anchor) {
      const element = document.querySelector(anchor);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }, 100);
      }
    },
    handleNavChange(item) {
      if (item.anchor) {
        this.activeAnchor = item.anchor;
        this.scrollToAnchor(item.anchor);
        history.pushState(null, null, item.anchor);
      }
    },
    changeTab(index) {
      this.currentIndex = index;
      if (this.currentIndex == 1) {
        this.$router.push({
          name: "recruitment",
        });
      }
    },
    showFullImage(img) {
      this.currentImage = img;
      this.showModal = true;
      document.body.style.overflow = "hidden";
    },
    closeModal() {
      this.showModal = false;
      document.body.style.overflow = "";
    },
    switchImage(img) {
      this.currentImage = img;
    },
    moveToFront(id) {
      // 将选中的证书卡片移到最前面
      const cards = document.querySelectorAll(".certificate-card");
      cards.forEach((card) => {
        if (card.dataset.id === id.toString()) {
          card.style.zIndex = "100";
        } else {
          card.style.zIndex = "1";
        }
      });
    },
    handleScroll: debounce(function () {
      const sections = [
        "#intro",
        "#history",
        "#partners",
        "#certificates",
        "#news",
        "#contact",
      ];
      const scrollPosition = window.scrollY + 1135;
      let currentSection = "#intro";
      for (const section of sections) {
        const element = document.querySelector(section);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetHeight = element.offsetHeight;
          if (
            scrollPosition >= offsetTop - 280 &&
            scrollPosition < offsetTop + offsetHeight - 280
          ) {
            currentSection = section;
            break;
          }
        }
      }
      if (this.activeAnchor !== currentSection) {
        this.activeAnchor = currentSection;
      }
    }, 100),
  },
  mounted() {
    this.getDynamicList();
    window.addEventListener("scroll", this.handleScroll);
    const handleAnchor = () => {
      if (window.location.hash) {
        this.activeAnchor = window.location.hash;
        const element = document.querySelector(window.location.hash);
        if (element) {
          setTimeout(() => {
            element.scrollIntoView({
              behavior: "smooth",
            });
          }, 100);
        }
      } else {
        this.handleScroll();
      }
    };
    handleAnchor();
    this.$watch(
      () => this.$route.hash,
      (newHash, oldHash) => {
        if (newHash !== oldHash) {
          handleAnchor();
        }
      }
    );
  },
};
</script>

<style scoped lang="scss">
// 新闻样式开始
.news-container {
  max-width: 1000px;
  margin: 40px auto;
  padding: 0 20px;
}

.news-item {
  display: flex;
  align-items: flex-start;
  padding: 16px 0;
  border-bottom: 1px solid #e5e5e5;
  background: #fff;
}

.f2 {
  margin-bottom: -10px;
}

.content-row {
  display: flex;
  align-items: stretch;
  margin-bottom: 8px;
}

.page-title {
  font-size: 26px;
  margin-bottom: 30px;
  color: #222;
  font-weight: normal;
  border-bottom: 1px solid #eee;
  padding-bottom: 15px;
}

.news-list {
  max-width: 900px;
  margin: 0 auto;
  background: #fff;
  border-radius: 0;
  box-shadow: none;
}

.news-item {
  display: flex;
  align-items: flex-start;
  padding: 32px 0;
  border-bottom: 1px solid #e5e5e5;
  background: #fff;
}

.news-item:last-child {
  border-bottom: none;
}

.news-date {
  width: 90px;
  text-align: center;
  margin-right: 32px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

.news-day {
  font-size: 38px;
  font-weight: bold;
  color: #222;
  line-height: 1;
  margin-bottom: 2px;
}

.news-month-year {
  font-size: 16px;
  color: #999;
  letter-spacing: 1px;
}

.news-content {
  flex: 1;
  text-align: left;
}

.news-title {
  font-size: 18px;
  color: #222;
  font-weight: bold;
  margin-bottom: 10px;
}

.news-summary {
  font-size: 15px;
  color: #888;
  margin-bottom: 18px;
  line-height: 1.7;
}

.read-more-btn {
  display: inline-block;
  color: #ff4d4f;
  border: 1px solid #ff4d4f;
  background: #fff;
  font-size: 15px;
  padding: 6px 24px;
  border-radius: 4px;
  text-decoration: none;
  transition: all 0.2s;
  margin-top: 0;
  margin-bottom: 0;
  text-align: left;
  height: 36px;
  line-height: 24px;
  font-weight: 500;
}

.read-more-btn:hover {
  background: #ff4d4f;
  color: #fff;
  text-decoration: none;
}

@media (max-width: 768px) {
  .news-list {
    max-width: 100%;
    padding: 0 10px;
  }

  .news-item {
    flex-direction: column;
    padding: 20px 0;
  }

  .news-date {
    flex-direction: row;
    width: 100%;
    margin-bottom: 10px;
    justify-content: flex-start;
    text-align: left;
  }

  .news-day {
    font-size: 28px;
    margin-right: 10px;
  }

  .news-month-year {
    font-size: 14px;
    margin-top: 0;
  }
}

//新闻样式结束

/* 添加锚点跳转的样式调整 */
[id] {
  scroll-margin-top: 20%;
  /* 防止导航栏遮挡 */
  padding-top: 20px;
}

/* 添加平滑滚动效果 */
html {
  scroll-behavior: smooth;
}

.lianxi {
  width: 100%;
  margin-bottom: 1%;
}

.dontai {
  margin-top: 1%;
  width: auto;
  height: auto;
}

.kuangdu {
  // margin-top: -100px;
  margin-top: -8%;
}

.top-title {
  font-size: 35px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 55.5px;
  color: rgba(46, 49, 51, 1);
  text-align: center;
  vertical-align: top;
  margin-bottom: 5%;
}

// big
/* 新增模态框样式 */
.image-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  position: relative;
  margin-top: -500px;
  max-width: 30%;
  max-height: 30%;
}

.image-content img {
  position: relative;
  left: 20px;
  // margin-left: 30px;
  margin-bottom: 13px;
  width: auto;
  max-height: 50%;
}

.image-nav {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  gap: 10px;
}

.image-nav .nav-item {
  width: 60px;
  height: 40px;
  cursor: pointer;
  opacity: 0.7;
  transition: all 0.3s;
  border: 2px solid transparent;
}

.image-nav .nav-item:hover,
.image-nav .nav-item.active {
  opacity: 1;
  border-color: #fff;
}

.image-nav img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.close-btn {
  position: absolute;
  top: -40px;
  right: 0;
  background: none;
  border: none;
  color: white;
  font-size: 30px;
  cursor: pointer;
}

/* 保留原有的悬停效果 */
.certificate-card:hover .certificate-img-container {
  transform: scale(1.05);
  transition: transform 0.3s ease;
}

.certificate-card:hover img {
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25);
}

/* 主容器 - 精确尺寸控制 */
.company-certificates {
  position: relative;
  width: 100%;
  height: 500px;
  /* 根据内容自动调整 */
  margin: 0 auto;
  text-align: center;
}

/* 证书组容器 - 精确包裹内容 */
.certificate-group {
  position: absolute;
  display: inline-block;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  /* 防止卡片换行 */
}

/* 证书卡片 - 完全匹配图片尺寸 */
.certificate-card {
  display: inline-block;
  position: relative;
  margin: 0 10px;
  vertical-align: top;
  position: relative;
  z-index: 1;
}

/* 图片容器 - 消除所有多余空间 */
.certificate-img-container {
  display: inline-block;
  line-height: 0;
  position: relative;
}

/* 图片样式 - 精确控制 */
.certificate-img-container img {
  display: block;
  height: auto;
  // border-radius: 8px;
  // border: 1px solid #eee;
  // box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

/* 尺寸控制 - 严格匹配设计 */
.large img {
  height: 500px;
}

.medium img {
  height: 400px;
  // width: 400px;
}

.small img {
  height: 350px;
}

/* 层级定位 */
.center-layer {
  z-index: 30;
  top: 42%;
  transform: translateX(-50%) translateY(-50%);
}

.middle-layer {
  z-index: 20;
  top: 35%;
  transform: translateX(-50%) translateY(-40%);
}

.outer-layer {
  z-index: 10;
  top: 27%;
  transform: translateX(-50%) translateY(-30%);
}

/* 水平定位 - 精确偏移 */
.left-outer {
  transform: translateX(-103%);
}

.right-outer {
  transform: translateX(93%);
}

.left-middle {
  transform: translateX(-37%);
}

.right-middle {
  transform: translateX(22%);
}

/* 悬停效果 - 提升用户体验 */
.certificate-card:hover {
  z-index: 100;
}

.certificate-card:hover .certificate-img-container {
  transform: scale(1.05);
  transition: transform 0.3s ease;
}

.certificate-card:hover img {
  // box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25);
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .large img {
    width: 450px;
  }

  .medium img {
    width: 360px;
  }

  .small img {
    width: 280px;
  }

  .left-outer {
    transform: translateX(-100%);
  }

  .right-outer {
    transform: translateX(0);
  }
}

@media (max-width: 768px) {
  .company-certificates {
    height: auto;
    padding: 80px 0;
  }

  .certificate-group {
    position: relative;
    display: block;
    left: auto;
    transform: none !important;
    margin-bottom: 30px;
    white-space: normal;
  }

  .certificate-card {
    display: block;
    margin: 20px auto;
    transform: none !important;
  }

  .large img,
  .medium img,
  .small img {
    width: 100%;
    max-width: 400px;
  }

  .center-layer,
  .middle-layer,
  .outer-layer {
    top: auto;
    transform: none !important;
  }
}

.partners-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  z-index: 2;
}

.partners-title {
  font-family: "Source Han Sans CN", "思源黑体", "Microsoft YaHei", sans-serif;
  // margin-bottom: 25%;
  font-size: 35px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 40px;
  color: rgba(46, 49, 51, 1);
  text-align: center;
  vertical-align: top;
}

.service {
  margin-top: -6%;
  // 创建父定位
  height: 600px;
  position: relative;
  width: 100%;
  display: flex;
  // 水品居中
  justify-content: center;
  // 垂直居中
  align-items: center;
}

.houbanbeijing {
  width: 100%;
}

.hezuohuobanbeijing {
  width: 100%;
  height: auto;
  /* 保持原始比例 */
  display: block;
}

.hezuoimg {
  // 子定位
  position: absolute;
  //垂直
  top: 50%;
  //水平居中
  left: 50%;
  transform: translate(-50%, -35%);
  width: 90%;
  z-index: 2;
}

.fazhan-container {
  margin-top: -100px;
  height: 500px;
  position: relative;
  /* 创建定位上下文 */
  width: 100%;
  display: flex;
  justify-content: center;
  /* 水平居中 */
  align-items: center;
  /* 垂直居中 */
}

.fazhan-background {
  width: 100%;
}

.background-img {
  width: 100%;
  height: auto;
  /* 保持原始比例 */
  display: block;
}

.fazhan-overlay {
  position: absolute;
  /* 绝对定位覆盖 */
  top: 50%;
  /* 垂直居中 */
  left: 50%;
  /* 水平居中 */
  transform: translate(-50%, -50%);
  /* 精确居中 */
  width: 80%;
  /* 按需调整宽度 */
  z-index: 2;

  /* 确保在上层 */
  .fanzhanlicheng {
    margin-bottom: 4.5%;
    font-size: 35px;
    font-weight: 700;
    letter-spacing: 0px;
    line-height: 55.5px;
    color: rgba(46, 49, 51, 1);
    text-align: center;
    vertical-align: top;
  }
}

.overlay-img {
  width: 100%;
  height: auto;
  object-fit: contain;
  /* 防止模糊 */
  display: block;
}

.leasing-container ul li img {
  width: 10px;
  height: 10px;
  object-fit: contain;
  margin-top: 20px;
  margin-right: 15px;
}

.leasing-container {
  max-width: 1440px;
  margin: 0 auto;
  padding: 40px 20px;
}

.content-row {
  display: flex;
  align-items: center;
  align-items: center;
  margin-bottom: 60px;
}

.reverse {
  flex-direction: row-reverse;
}

.reverse .text-content {
  padding-right: 0;
  padding-left: 10px;
}

ul {
  list-style-type: none;
  padding-left: 0;
}

li {
  position: relative;
  margin-left: -100px;
  // padding-left: -50px;
  margin-bottom: 20px;
  line-height: 1.6;
  color: #444;
}

.text-content li {
  margin-left: 50px;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0.5px;
  line-height: 37px;
  color: rgba(103, 103, 103, 1);
  text-align: justify;
  vertical-align: top;
  width: 490px;
  height: 150px;
  // justify-content: center;
}

.leasing-container ul li img {
  width: 10px;
  height: 10px;
  object-fit: contain;
  // margin-top: 20px;
  margin-right: 15px;
}

.leasing-container {
  width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

.wrap {
  width: 100%;

  .bannerimg {
    position: relative;

    .biaotowenzi {
      position: absolute;
      top: 50%;
      /* 垂直居中 */
      left: 12%;
      /* 水平靠左（可根据需求调整百分比） */
      transform: translateY(-50%);
      /* 精确垂直居中 */
      color: white;
      /* 文字颜色 */
      text-align: left;
      /* 文字左对齐 */
      max-width: 80%;
      /* 防止文字过长 */
      padding: 20px;
      /* 文字内边距 */
      z-index: 2;
      /* 确保文字在图片上方 */

      h2 {
        font-size: 35px;
        font-weight: 500;
        letter-spacing: 0px;
        color: rgba(255, 255, 255, 1);
        text-align: left;
        vertical-align: top;
      }

      p {
        font-size: 22px;
        font-weight: 500;
        letter-spacing: 0px;
        color: rgba(255, 255, 255, 1);
        text-align: left;
        vertical-align: top;
      }
    }
  }

  .tab {
    width: 100%;
    height: 50px;
    background-color: #f4f9ff;

    .item-box {
      display: flex;
      // width: 1200px;
      margin: 0 auto;

      .item {
        width: 150px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        font-weight: bold;
      }

      .active {
        background-color: #5197d5;
        color: #fff;
      }
    }
  }

  .content {
    margin-top: 20px;

    .logo {
      font-weight: bold;

      .top-txt {
        font-size: 35px;
      }
    }

    .info-content {
      padding: 20px 20px 30px 20px;
      line-height: 30px;
      text-align: left;
      font-size: 16px;
    }

    .img-box {
      display: flex;
      justify-content: space-between;

      .item {
        position: relative;
        width: 400px;
        height: 200px;

        img {
          width: 400px;
          height: 200px;
        }

        .txt {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-weight: bold;
          color: rgb(255, 255, 255);

          .name {
            margin-top: 10px;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.workspace-footer.footerbox {
  margin-top: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/view/Match/workspace.vue